import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.roles.edit', {
        url: '/:roleId/edit',
        views: {
            '@company.manage-application': 'companyManageApplicationRolesEdit',
        },
        resolve: {
            role,
            roleId,
        }
    });
}

/** @ngInject */
function role(roleId, roles) {
    return roles.find((role) => role.loginRole.id === roleId);
}

/** @ngInject */
function roleId($stateParams) {
    return $stateParams.roleId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/edit/edit-role.state.js